import { ImportLegacyFeaturesConfig } from './ImportLegacyFeaturesConfig';

export const defaultImportLegacyFeaturesConfig: ImportLegacyFeaturesConfig = {};
